import PropTypes from 'prop-types'
import React from 'react'
import {
  convertKanBoFormatToContentState
} from '../utils/convert'

const RichTextInlineContent = ({ content, ...props }) => {
  let text = null

  if (content) {
    text = convertKanBoFormatToContentState(content).getPlainText(' ')
  }

  return <span {...props}>{text}</span>
}

RichTextInlineContent.propTypes = {
  content: PropTypes.object
}

export default RichTextInlineContent
